var map = {
	"./basic/routes.js": 5775,
	"./buildium/routes.js": 5468,
	"./files/routes.js": 4736,
	"./page/routes.js": 2094,
	"./settings/routes.js": 5464,
	"./sterling/routes.js": 5487,
	"./user/routes.js": 2514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5243;